import React from 'react';
import { Link } from 'react-router-dom';
import { CAPABILITIES } from '../data/site';
import '../styles/capabilities.css';

/**
 * Everything we do, one line each. The founders asked that nothing JK does
 * goes unmentioned: the CRM, SEO, the video pipeline and the workflows had
 * no home on the page before this. Each item links to where the detail is.
 */
const Capabilities: React.FC = () => (
  <section id="everything" className="band band--tint" aria-labelledby="everything-title">
    <div className="shell">
      <div className="lede-row">
        <h2 className="h2" id="everything-title">Everything we do, in one place.</h2>
        <p>The short version. Each line links to the detail, and every one of them ends with you approving the work.</p>
      </div>

      <ul className="caps">
        {CAPABILITIES.map((c) => {
          const external = c.href.startsWith('http');
          const body = (
            <>
              <span className="caps__name">
                {c.name}
                {c.status && <span className="caps__status">{c.status}</span>}
              </span>
              <span className="caps__line">{c.line}</span>
            </>
          );
          return (
            <li className="caps__item" key={c.id}>
              {external ? (
                <a className="caps__link" href={c.href} target="_blank" rel="noopener noreferrer">{body}</a>
              ) : (
                <Link className="caps__link" to={c.href}>{body}</Link>
              )}
            </li>
          );
        })}
      </ul>
    </div>
  </section>
);

export default React.memo(Capabilities);
